import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';

export const QuestionTitle = ({ q }) => {
  const { t } = useTranslation();
  return (
    <>
      {q.title ? (
        <div className="question-title">
          {t(q.title)}
        </div>
      ) : null}
      {q.subtitle ? (
        <div className="question-subtitle">
          {t(q.subtitle)}
        </div>
      ) : null}
    </>
  );
};

QuestionTitle.propTypes = {
  q: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
};
